import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CenterContainer } from './components/containers';
import { LoadingSpinner } from './components/loaders';
import { validateToken } from './container/LoginPage/action';
import { selectIsUserAuthorized, getUser, selectUserIsActive, selectUserType } from './selectors';
import { PAGE_CUSTOMER, DEFAULT_CUSTOMER_PAGE, PAGE_GENERAL, PAGE_ADMIN, DEFAULT_ADMIN_PAGE } from './App';
import { USER_TYPE } from './constants';
import axios from 'axios';
import { API } from './index';

const AUTHORIZATION_STATUS = {
    Validating: 1,
    Success: 2,
    Error: -1,
};

const propTypes = {
    children: PropTypes.node.isRequired,
};

const mapStateToProps = state => ({
    isUserLoggedIn: selectIsUserAuthorized(state),
    isUserActive: selectUserIsActive(state),
    userData: getUser(state),
    userType: selectUserType(state),
});

const mapDispatchToProps = dispatch => ({
    validateSavedUserToken: bindActionCreators(validateToken, dispatch),
});

class CheckAuthorization extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            status: AUTHORIZATION_STATUS.Validating,
        };
    }

    componentDidMount() {
        if (this.props.isUserLoggedIn) {
            this.setState({
                status: AUTHORIZATION_STATUS.Success,
            });
        } else {
            this.props
                .validateSavedUserToken()
                .then(loggedIn => {
                    this.setState({
                        status: AUTHORIZATION_STATUS.Success,
                    });
                })
                .catch(notLoggedIn => {
                    this.setState({
                        status: AUTHORIZATION_STATUS.Error,
                    });
                });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isUserLoggedIn && nextProps.isUserLoggedIn === false) {
            this.setState({
                status: AUTHORIZATION_STATUS.Error,
            });
        } else if (nextProps.isUserLoggedIn) {
            this.setState({
                status: AUTHORIZATION_STATUS.Success,
            });
        }
    }

    render() {
        let { children, isUserLoggedIn, isUserActive, userData, userType } = this.props;

        // Get current pathname
        const path = window.location.pathname;

        // Check if user is on any specific group of pages
        const isOnLoginPages = Object.keys(PAGE_GENERAL).some(key => {
            return PAGE_GENERAL[key] !== '/' && path.includes(PAGE_GENERAL[key]) ? true : false;
        });
        const isOnCustomerPages = Object.keys(PAGE_CUSTOMER).some(key => {
            return path.includes(PAGE_CUSTOMER[key]) ? true : false;
        });
        const isOnAdminPages = Object.keys(PAGE_ADMIN).some(key => {
            return path.includes(PAGE_ADMIN[key]) ? true : false;
        });

        // Check user type
        const isAdmin = userType === USER_TYPE.Admin;
        const isCustomer = userType === USER_TYPE.Customer;

        // Redirect to default page when user is authorized but on login page
        if (isUserLoggedIn && isUserActive && isOnLoginPages && (isAdmin || isCustomer)) {
            return <Redirect to={isAdmin ? DEFAULT_ADMIN_PAGE : DEFAULT_CUSTOMER_PAGE} />;
        }

        // When validating user show loader
        if (
            this.state.status === AUTHORIZATION_STATUS.Validating ||
            (this.state.status === AUTHORIZATION_STATUS.Success && isUserLoggedIn === false)
        ) {
            return (
                <CenterContainer>
                    <LoadingSpinner size={64} />
                </CenterContainer>
            );
        }

        // If user is not logged in and on root page, redirect to login form
        if (path === '/') {
            <Redirect to={PAGE_GENERAL.Login} />;
        }

        // Show current page when user is on login pages or authorized
        if (isOnLoginPages || (isUserActive && ((isAdmin && isOnAdminPages) || (isCustomer && isOnCustomerPages)))) {
            return children;
        }

        // Otherwise redirect to login form
        return <Redirect to={PAGE_GENERAL.Login} />;
    }
}

CheckAuthorization.propTypes = propTypes;

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckAuthorization);



// WEBPACK FOOTER //
// ./app/web/src/CheckAuthorization.jsx